import styled from 'styled-components'

import Icon from '../../Icon'

const StyledIcon: any = styled(Icon)`
  margin-left: ${(props: any) => (props.hasLeftSibling ? props.theme.spacing.xs : 0)};
`

export default StyledIcon
